import { Injectable } from '@angular/core';

import { ConfigurationCompanySaleModel } from 'src/app/models/Configurations/ConfigurationCompanySaleModel';
import { ConfigurationOptions, ConfigurationProductModel } from 'src/app/models/Configurations/ConfigurationProductModel';
import { ConfigurationCompanyProductModel } from '../../../models/Configurations/ConfigurationCompanyProductModel';
import { ApiService } from '../../api/api.service';
import { ConfigurationCompanyService } from '../../configuration-company/configuration-company.service';

@Injectable({
  providedIn: 'root'
})
export class WizardProductService {
  //Configurations already set by user
  private _configurationSet: ConfigurationCompanyProductModel[] = [];
  set setConfiguration(config: ConfigurationCompanyProductModel[]) {
    this._configurationSet = config;
  }
  get getConfigurationSet(): ConfigurationCompanyProductModel[] {
    return this._configurationSet;
  }

  constructor(private api: ApiService, private configCompany: ConfigurationCompanyService) { }

  async setConfigurationOption(step: string, option: ConfigurationOptions) {
    if (step == 'product_code')
      await this.configCompany.setEmitNFCeConfiguration(option.configurationId, option.id)
    else if (step == 'use_nfce')
      await this.configCompany.setProductInventoryConfiguration(option.configurationId, option.id)
  }

  async getConfigurations(): Promise<ConfigurationProductModel[]> {
    const r = await this.api.get<ConfigurationProductModel[]>('/v1/product/config-product')
    if (r.success) {
      return r.data;
    } else { throw new Error(r.message) }
  }

  async configurationSet(): Promise<ConfigurationCompanyProductModel[]> {
    const r = await this.api.get<ConfigurationCompanyProductModel[]>('/v1/product/config-company-product')
    if (r.success) {
      return r.data;
    } else { throw new Error(r.message) }
  }

  async configurationsPaymentMethodsSet(): Promise<ConfigurationCompanySaleModel[]> {
    const r = await this.api.get<ConfigurationCompanySaleModel[]>('/v1/configuration-company/payment-methods')
    if (r.success) {
      return r.data;
    } else { throw new Error(r.message) }
  }
}
